import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/index/title.png")